import { X, Check } from "lucide-react";
import { BEFORE, AFTER } from "../data/site";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

export const BeforeAfter = () => (
    <section className="py-16 sm:py-24 lg:py-32" data-testid="before-after-section">
        <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
            <SectionHeading
                chapter="03"
                kicker="Before / After"
                title="What changes when the journey is connected."
                testid="before-after-heading"
            />
            <div className="mt-12 grid gap-6 lg:grid-cols-2">
                <Reveal>
                    <div className="h-full rounded-2xl border border-brand-brown/10 bg-brand-cream p-8 sm:p-10" data-testid="before-panel">
                        <p className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-brand-muted">Before</p>
                        <h3 className="mt-3 font-display text-2xl font-bold text-brand-brown">Scattered marketing</h3>
                        <ul className="mt-7 space-y-4">
                            {BEFORE.map((item) => (
                                <li key={item} className="flex items-start gap-3 text-sm leading-relaxed text-brand-muted sm:text-base">
                                    <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full border border-brand-brown/20 text-brand-brown/60">
                                        <X size={13} aria-hidden="true" />
                                    </span>
                                    {item}
                                </li>
                            ))}
                        </ul>
                    </div>
                </Reveal>
                <Reveal delay={0.12}>
                    <div className="h-full rounded-2xl bg-brand-brown-deep p-8 sm:p-10" data-testid="after-panel">
                        <p className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-brand-orange">After</p>
                        <h3 className="mt-3 font-display text-2xl font-bold text-brand-paper">The 033 system</h3>
                        <ul className="mt-7 space-y-4">
                            {AFTER.map((item) => (
                                <li key={item} className="flex items-start gap-3 text-sm leading-relaxed text-brand-cream/85 sm:text-base">
                                    <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brand-orange text-white">
                                        <Check size={13} aria-hidden="true" />
                                    </span>
                                    {item}
                                </li>
                            ))}
                        </ul>
                    </div>
                </Reveal>
            </div>
        </div>
    </section>
);
